"use client";

import { c as _c } from "react/compiler-runtime";
import { OrganizationBillingContent } from "@/components/billing/organization-billing-content";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@/components/ui/dialog";

/** Non-dismissible billing wall shown over the workspace until a plan is active. */
export function SubscriptionRequiredDialog() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <Dialog disablePointerDismissal={true} open={true}><DialogContent className="max-h-[calc(100dvh-2rem)] overflow-y-auto sm:max-w-3xl" showCloseButton={false}><DialogHeader className="sr-only"><DialogTitle>Assinatura obrigatória</DialogTitle><DialogDescription>Escolha um plano para ativar o acesso deste workspace.</DialogDescription></DialogHeader><OrganizationBillingContent mode="required" /></DialogContent></Dialog>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}